import { Button, Modal } from "react-bootstrap";
import React, { useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import './LogoutModal.scss';
import useLoader from "../../../contexts/LoaderContext";
import { useAuth } from '../../../services/authService';
import { useHeaderMenu } from "../../../contexts/login.context";
import { useTranslation } from "react-i18next";
interface LogoutModalProps {
    show: boolean;
    onHide: () => void;
}
const LogoutModal: React.FC<LogoutModalProps> = (LogoutModalProps) => {
    const { t } = useTranslation();
    const { showLoader, hideLoader } = useLoader();
    const navigate = useNavigate();
    const locale = window.location.pathname.split('/')[1];

    const { setLoginStatus, setItemsInCart } = useHeaderMenu();
    const { LogoutUser } = useAuth();
    const handleEmpty = (msg) => {
        navigate(`/${locale}/cart/empty`, { state: { msg } })
    }
    const handleLogoutSuccess = useCallback(() => {
        setItemsInCart(0);
        LogoutModalProps.onHide();
        window.location.href = 'https://' + window.location.host + '/' + locale + '/cart'
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleLogoutError = useCallback(() => {
        LogoutModalProps.onHide();
        handleEmpty(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const logout = async (e: React.MouseEvent<HTMLButtonElement>) => {
        showLoader();
        e.preventDefault();
        try {
            await LogoutUser(handleLogoutSuccess, handleLogoutError);
            setLoginStatus(false)
            hideLoader();
        } catch (error) {
            hideLoader();
        }
    }
    return (
        <Modal
            {...LogoutModalProps}
            aria-labelledby="logout-modal-title"
            aria-modal="true"
            role="dialog"
            aria-describedby="logout-modal-message"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="logout-modal-title" aria-label={t('LOGOUT_CONFIRMATION_TITLE')}>
                    {t('LOGOUT_CONFIRMATION_TITLE') /* e.g., "Logout Confirmation" */}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p id="logout-modal-message" className='text-center' aria-label={t('LOGOUT_MODAL_MESSAGE')}>
                    {t('LOGOUT_MODAL_MESSAGE')}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="btn-green-outline"
                    variant="outline-success"
                    onClick={logout}
                    aria-label={t('LOGOUT')}
                    autoFocus
                >
                    {t('LOGOUT')}
                </Button>
                <Button
                    className="btn-dark-outline"
                    variant="outline-dark"
                    onClick={LogoutModalProps.onHide}
                    aria-label={t('CLOSE')}
                >
                    {t('CLOSE')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
export default LogoutModal